import { useState, useEffect } from "react";

export default function useResizeObserver(target, cb) {

    const [observer, setObserver] = useState(null);

    useEffect(() => {
        const obs = new ResizeObserver(cb);
        setObserver(obs);
    }, []);

    useEffect(() => {
        if (!observer) return;
        observer.observe(target);
        return () => {
            if (observer) observer.disconnect();
        };
    }, [observer, target]);


}